import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fillColor?: string;
	styles?: StyleDeclarationValue[];
}

export const WritebackIcon: React.FC<IProps> = props => {
	const { className, fillColor = '#C75DA6', styles = [] } = props;
	return (
		<SvgIcon className={`${css(...styles)} ${className || ''}`} height={24} width={24}>
			<g fill={fillColor} fillRule='evenodd'>
				<path d='M2 6.6C3.736 7.522 6.374 8 9 8 11.626 8 14.264 7.522 16 6.6L16 8C16 8.58 13.547 10 9 10 4.453 10 2 8.58 2 8L2 6.6ZM9 2C13.547 2 16 3.419 16 4 16 4.58 13.547 6 9 6 4.453 6 2 4.58 2 4 2 3.419 4.453 2 9 2L9 2ZM11 17.898C10.385 17.961 9.722 18 9 18 4.453 18 2 16.58 2 16L2 14.6C3.736 15.522 6.374 16 9 16 9.671 16 10.343 15.968 11 15.906L11 13.898C10.385 13.961 9.722 14 9 14 4.453 14 2 12.58 2 12L2 10.6C3.736 11.522 6.374 12 9 12 11.626 12 14.264 11.522 16 10.6L16 11 18 11 18 4C18 1.374 13.473 0 9 0 4.527 0 0 1.374 0 4L0 16C0 18.626 4.527 20 9 20 9.671 20 10.342 19.965 11 19.904L11 17.898ZM20 16.586 18.414 15 20 13.414 21.586 15 20 16.586ZM15.488 21.098 13.375 21.626 13.902 19.511 17 16.414 18.586 18 15.488 21.098ZM23.707 14.293 20.707 11.293C20.316 10.902 19.684 10.902 19.293 11.293L12.293 18.293C12.164 18.421 12.074 18.582 12.029 18.757L11.029 22.757C10.945 23.098 11.045 23.459 11.293 23.707 11.482 23.897 11.738 24 12 24 12.08 24 12.162 23.99 12.242 23.971L16.242 22.971C16.418 22.927 16.579 22.835 16.707 22.707L23.707 15.707C24.098 15.316 24.098 14.684 23.707 14.293L23.707 14.293Z' />
			</g>
		</SvgIcon>
	);
};
